import React from 'react';
import clsx from 'clsx';

import ModifyButton from 'components/atoms/Button/ModifyButton';
import './index.scss';

const PcConfItem = ({
  title,
  modifyLinks = [],
  type = 'noTitle',
  items = [],
  changeModifyMode = () => {},
}) => {

  // 1段組
  const NoTitleItem = ({ items: noTitleItems }) => (
    <div className="NoTitleItem">
      {noTitleItems.map(item => (
        <div key={item} className="item-one-line">
          {item}
        </div>
      ))}
    </div>
  );

  // 2段組
  const WithTitleItem = ({ items: withTitleItems }) => {
    return(
      <div className="WithTitleItem">
        {withTitleItems.map(item => {
          return(
            <div key={item.title}>
              <div key={item.title} className={clsx('item-one-line', { fullWidth: !!item.fullWidth })}>
                <div className="item-title">
                  {Array.isArray(item.title)
                    ? item.title.map(line => (
                      <span key={line} className="">
                        <span className="conf-title">
                          {line}
                          <br />
                        </span>
                      </span>
                    ))
                    : <>{item.title}</>}
                </div>
                <div className="item-content">
                  {Array.isArray(item.content)
                    ? item.content.map(line => {
                      return(
                        <span key={line.workStyleKbn} className="">
                          {line.startTime}
                          {' '}
                          -
                          {' '}
                          {line.endTime}
                          {' '}
                          <span className="content-restTime">
                            休憩時間
                            {' '}
                          </span>
                          {line.restTime}
                          {' '}
                          分
                          <br />
                        </span>
                      );
                    })
                    : <>{item.content}</>}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  
  return (
    <div className="PcConfItem"> 
      <div className="wrapper">
        <div className="title-wrapper">
          <div className="title">
            {title}
          </div>
          <div className="modify-button-area">
            {modifyLinks.map(link => (
              <div key={link} className="modify-button">
                <ModifyButton link={link} onClick={changeModifyMode} />
              </div>
            ))}
          </div>
        </div>
        <div className="items">
          {type === 'noTitle' ? <NoTitleItem items={items} /> : <WithTitleItem items={items} />}
        </div>
      </div>
    </div>
  );
};

export default PcConfItem;